import utils from '../../../../../components/Organisms/Form/utils'

const config = utils.injectTranslation({
  id: 'PrincipalActivitiesForm',
  path: 'onboarding.forms.CorporateAccount.PrincipalActivitiesForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'principalActivityDesc',
            isTextarea: true,
            removeLabelEllipsis: true,
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto',
            maxlength: 500,
          },
        },
      ],
    },
  ],
})

export default config
